import React from "react";
import PropTypes from "prop-types";

import TableContainer from "./common/TableContainer";
import ThreatsTable, { getRows } from "./ThreatsTable";

/*
Component
*/

const Threats = ({
  dataSelector,
  fetchData,
  idSelector,
  intervalSelector,
  refresh,
}) => (
  <TableContainer
    dataSelector={dataSelector}
    fetchData={fetchData}
    getRows={getRows}
    idSelector={idSelector}
    intervalSelector={intervalSelector}
    refresh={refresh}
    Table={ThreatsTable}
  />
);

Threats.propTypes = {
  dataSelector: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  idSelector: PropTypes.func.isRequired,
  intervalSelector: PropTypes.func.isRequired,
  refresh: PropTypes.bool,
};

Threats.defaultProps = {
  refresh: false,
};

export default Threats;
